import { Api } from "@relode/core";
import {
    MarketResearchCompensationResponse,
    MarketResearchDiversityResponse,
    MarketResearchSummaryResponse,
    MarketResearchSupplyDemandResponse,
} from "@relode/core/backend/marketResearch";

import { JobPublicMarketResearchResponse } from ".";

export const jobsPublicService = {
    getJob: async (token: string) => {
        const url = `/public/jobs?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "jobsPublicService.getJob",
                data: { token },
            })
            .get<JobPublicMarketResearchResponse>();

        return response;
    },

    getMarketResearchCompensation: async (token: string) => {
        const url = `/public/jobs/market-research/compensation?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "jobsPublicService.getMarketResearchCompensation",
                data: { token },
            })
            .get<MarketResearchCompensationResponse>();

        return response;
    },

    getMarketResearchSupplyDemand: async (token: string) => {
        const url = `/public/jobs/market-research/supply-demand?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "jobsPublicService.getMarketResearchSupplyDemand",
                data: { token },
            })
            .get<MarketResearchSupplyDemandResponse>();

        return response;
    },

    getMarketResearchDiversity: async (token: string) => {
        const url = `/public/jobs/market-research/diversity?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "jobsPublicService.getMarketResearchDiversity",
                data: { token },
            })
            .get<MarketResearchDiversityResponse>();

        return response;
    },

    getMarketResearchSummary: async (token: string) => {
        const url = `/public/jobs/market-research/summary?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "jobsPublicService.getMarketResearchSummary",
                data: { token },
            })
            .get<MarketResearchSummaryResponse>();

        return response;
    },
};
